<script setup>
import {useI18n} from 'vue-i18n';
import {formatAmount} from '@/helper';

/**
 * IMA-517 fáze 10: platební údaje nákupu dluhopisu (BE BondPurchaseService::paymentInfo).
 * Rozložení jako na konci ASO/SO – QR kód vlevo, údaje vpravo. Používá konec průvodce nákupem
 * i modal „Platební údaje“ v záložce Pokyny.
 * U CZK se zobrazuje číslo účtu, IBAN a VS, u cizí měny IBAN, BIC/SWIFT a reference platby.
 */
defineProps({
  // {bank_account_number_full, iban, bic_swift, currency, variable_symbol, amount, message, qr_code_base64}
  payment: {type: Object, required: true},
});

const {t} = useI18n();
</script>

<template>
  <div class="row align-items-center g-3">
    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
      <div class="qr-code-wrapper">
        <img :src="payment.qr_code_base64" alt="QR" style="width: 200px;">
      </div>
    </div>
    <div class="col-12 col-md-6">
      <template v-if="payment.currency === 'CZK'">
        <div><span class="fw-bold">{{ t('bondPurchase.payment_account') }}: </span>{{ payment.bank_account_number_full }}</div>
        <!-- IBAN i u CZK – pro platbu ze zahraničního nebo slovenského účtu -->
        <div v-if="payment.iban"><span class="fw-bold">IBAN: </span>{{ payment.iban }}</div>
        <div><span class="fw-bold">{{ t('bondPurchase.payment_vs') }}: </span>{{ payment.variable_symbol }}</div>
      </template>
      <template v-else>
        <div><span class="fw-bold">IBAN: </span>{{ payment.iban ?? payment.bank_account_number_full }}</div>
        <div v-if="payment.bic_swift"><span class="fw-bold">BIC/SWIFT: </span>{{ payment.bic_swift }}</div>
        <div><span class="fw-bold">{{ t('bondPurchase.payment_reference') }}: </span>{{ payment.variable_symbol }}</div>
      </template>
      <div class="mt-2"><span class="fw-bold">{{ t('bondPurchase.payment_amount') }}: </span>{{ formatAmount(payment.amount, payment.currency) }}</div>
      <div v-if="payment.message"><span class="fw-bold">{{ t('bondPurchase.payment_message') }}: </span>{{ payment.message }}</div>
    </div>
  </div>
</template>
